var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasPermissionEx("bindGoogle") }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPermissionEx("bindGoogle"),
              expression: "hasPermissionEx('bindGoogle')"
            }
          ]
        },
        [
          _c("div", { staticClass: "make-title" }, [
            _vm._v(_vm._s(_vm.$t("route.bindGoogleCode")))
          ]),
          _vm._v(" "),
          _c(
            "el-card",
            { staticStyle: { "margin-bottom": "20px", color: "red" } },
            [
              _vm.$store.getters.isAgent
                ? _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.message63")) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.isMerchant
                ? _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.message77")) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "400px", "margin-left": "20px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.googleCodeTemp,
                "label-position": "left",
                "label-width": "150px"
              }
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-container", {
                    staticStyle: { width: "90vw", "margin-left": "20px" },
                    attrs: { id: "qrcode" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SMS.bingQrcode"),
                    prop: "googleVerifyCode"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      oninput: "if(value.length>6)value=value.slice(0,6)",
                      type: "number"
                    },
                    model: {
                      value: _vm.googleCodeTemp.googleVerifyCode,
                      callback: function($$v) {
                        _vm.$set(_vm.googleCodeTemp, "googleVerifyCode", $$v)
                      },
                      expression: "googleCodeTemp.googleVerifyCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.$store.getters.isAgent
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SMS.payPassword"),
                        prop: "payPassword"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: { type: "password", "show-password": "" },
                        model: {
                          value: _vm.googleCodeTemp.payPassword,
                          callback: function($$v) {
                            _vm.$set(_vm.googleCodeTemp, "payPassword", $$v)
                          },
                          expression: "googleCodeTemp.payPassword"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.isMerchant
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SMS.loginPassword"),
                        prop: "password"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: { type: "password", "show-password": "" },
                        model: {
                          value: _vm.googleCodeTemp.password,
                          callback: function($$v) {
                            _vm.$set(_vm.googleCodeTemp, "password", $$v)
                          },
                          expression: "googleCodeTemp.password"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "uniform-button",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.doResetTemp()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.reset")) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.$store.getters.isAgent
                        ? _vm.doUpdatePasswordForAgent()
                        : _vm.$store.getters.isMerchant
                        ? _vm.doUpdatePasswordForMerchant()
                        : null
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.confirm")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }